var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgListView = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "list-ul",
    d: "M33.333,64a1.333,1.333,0,1,0,1.333,1.333A1.333,1.333,0,0,0,33.333,64ZM38,64.667A.667.667,0,1,0,38,66H51.333a.667.667,0,1,0,0-1.333Zm0,6.667a.667.667,0,1,0,0,1.333H51.333a.667.667,0,0,0,0-1.333ZM38,78a.667.667,0,1,0,0,1.333H51.333a.667.667,0,0,0,0-1.333Zm-3.333-6a1.333,1.333,0,1,0-1.333,1.333A1.333,1.333,0,0,0,34.667,72Zm-1.333,5.333a1.333,1.333,0,1,0,1.333,1.333A1.333,1.333,0,0,0,33.333,77.333Z",
    transform: "translate(-32 -64)",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list-view.729a176758e6fde8cc1f4578b08f9c69.svg";